import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const UnfilledBookmark = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/unfilled-bookmark">
        <g id="unfilled-bookmark">
          <path
            id="Vector"
            d="M12.7109 15.1663C12.3709 15.1663 11.9976 15.0663 11.6376 14.8597L8.38427 13.053C8.19094 12.9463 7.81094 12.9463 7.6176 13.053L4.36427 14.8597C3.70427 15.2263 3.03094 15.2663 2.5176 14.9597C2.00427 14.6597 1.71094 14.053 1.71094 13.2997V3.90634C1.71094 2.21301 3.09094 0.833008 4.78427 0.833008H11.2176C12.9109 0.833008 14.2909 2.21301 14.2909 3.90634V13.2997C14.2909 14.053 13.9976 14.6597 13.4843 14.9597C13.2509 15.0997 12.9843 15.1663 12.7109 15.1663ZM7.9976 11.973C8.31094 11.973 8.6176 12.0397 8.86427 12.1797L12.1176 13.9863C12.4576 14.1797 12.7709 14.2197 12.9709 14.0997C13.1709 13.9797 13.2843 13.693 13.2843 13.2997V3.90634C13.2843 2.76634 12.3509 1.83301 11.2109 1.83301H4.78427C3.64427 1.83301 2.71094 2.76634 2.71094 3.90634V13.2997C2.71094 13.693 2.82427 13.9863 3.02427 14.0997C3.22427 14.213 3.5376 14.1797 3.8776 13.9863L7.13094 12.1797C7.3776 12.0397 7.68427 11.973 7.9976 11.973Z"
          />
        </g>
      </g>
    </svg>
  );
};

UnfilledBookmark.displayName = 'UnfilledBookmark';
